import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * Angular migration of processMapFactory.
 * Uses application/x-www-form-urlencoded or JSON as in original; withCredentials: true.
 */
@Injectable({ providedIn: 'root' })
export class ProcessMapService {
  constructor(private http: HttpClient) {}

  getTaxPlacematList(baseUrl: string, clientKey: string): Observable<any> {
    const url = `${baseUrl}/getTaxPlacematList?clientKey=${encodeURIComponent(clientKey)}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getMappedProcesses(baseUrl: string, clientKey: string, placematId: number | string): Observable<any> {
    const url = `${baseUrl}/getTaxPlacematDetails?clientKey=${encodeURIComponent(clientKey)}&placematId=${encodeURIComponent(String(placematId))}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getTasksHierarchy(adminBaseUrl: string, clientKey: string): Observable<any> {
    const url = `${adminBaseUrl}/getTaskDpc?clientKey=${encodeURIComponent(clientKey)}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  saveMappedProcesses(
    adminBaseUrl: string,
    data: string,
    clientKey: string,
    placematId: number | string,
    placematName: string
  ): Observable<any> {
    const url = `${adminBaseUrl}/saveTaxPlacematDetails`;
    const params = new URLSearchParams();
    params.set('data', data);
    params.set('clientKey', String(clientKey));
    params.set('placematId', String(placematId));
    params.set('placematName', String(placematName));
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
    return this.http.post<any>(url, params.toString(), { headers, withCredentials: true });
  }

  saveUpdatedProcesses(adminBaseUrl: string, data: string, placematId: number | string): Observable<any> {
    const url = `${adminBaseUrl}/updateTaxPMProcess?placemat_id=${encodeURIComponent(String(placematId))}`;
    const params = new URLSearchParams();
    params.set('data', data);
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
    return this.http.post<any>(url, params.toString(), { headers, withCredentials: true });
  }

  deleteMappedProcesses(
    adminBaseUrl: string,
    clientKey: string,
    processId: number | string,
    placematId: number | string
  ): Observable<any> {
    const url = `${adminBaseUrl}/removeTaxPMProcess?clientKey=${encodeURIComponent(clientKey)}&process_id=${encodeURIComponent(String(processId))}&placemat_id=${encodeURIComponent(String(placematId))}`;
    return this.http.post<any>(url, '', { withCredentials: true });
  }

  deleteTaxPlacemat(adminBaseUrl: string, clientKey: string, placematId: number | string): Observable<any> {
    const url = `${adminBaseUrl}/deletePlacemat?client_key=${encodeURIComponent(clientKey)}&placemat_id=${encodeURIComponent(String(placematId))}`;
    return this.http.delete<any>(url, { withCredentials: true });
  }
}
